import React from 'react';
import { Link } from 'react-router-dom';
import './privacy.css';

const Privacy = () => {
    return (
        <div className="privacy-page">
            {/* SUB VISUAL */}
            <section className="privacy-sub-visual">
                <div className="privacy-sub-overlay"></div>

                <div className="privacy-sub-inner">
                    <p>
                        PRIVACY POLICY
                    </p>

                    <h1>
                        개인정보처리방침
                    </h1>

                    <div className="privacy-breadcrumb">
                        <Link to="/">
                            HOME
                        </Link>

                        <span>
                            ›
                        </span>

                        <strong>
                            개인정보처리방침
                        </strong>
                    </div>
                </div>
            </section>

            {/* CONTENT */}
            <section className="privacy-content">
                <div className="privacy-container">
                    <div className="privacy-intro">
                        <p className="privacy-label">
                            PRIVACY POLICY
                        </p>

                        <h2>
                            엠티미디어는 고객님의 개인정보를
                            <br />
                            소중하게 보호합니다.
                        </h2>

                        <p>
                            엠티미디어는 개인정보 보호 관련 법령을 준수하며,
                            견적문의 및 상담 과정에서 수집되는 개인정보를
                            필요한 범위 내에서 안전하게 처리합니다.
                        </p>
                    </div>

                    <div className="privacy-policy">
                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                01
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    개인정보의 수집 및 이용 목적
                                </h3>

                                <p>
                                    엠티미디어는 다음의 목적을 위해 개인정보를 수집하고 이용합니다.
                                    수집된 개인정보는 아래 목적 이외의 용도로 이용하지 않습니다.
                                </p>

                                <ul>
                                    <li>
                                        LED 전광판 및 빔프로젝터 대여·렌탈 견적 상담
                                    </li>
                                    <li>
                                        행사 일정 및 설치 가능 여부 확인
                                    </li>
                                    <li>
                                        장비 구성 및 설치 환경 상담
                                    </li>
                                    <li>
                                        고객 문의에 대한 답변 및 연락
                                    </li>
                                    <li>
                                        예약 및 서비스 진행을 위한 고객 확인
                                    </li>
                                </ul>
                            </div>
                        </section>

                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                02
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    수집하는 개인정보 항목
                                </h3>

                                <p>
                                    견적문의 과정에서 다음과 같은 정보를 수집할 수 있습니다.
                                </p>

                                <div className="privacy-table-wrap">
                                    <table className="privacy-table">
                                        <thead>
                                            <tr>
                                                <th>
                                                    구분
                                                </th>

                                                <th>
                                                    수집 항목
                                                </th>

                                                <th>
                                                    이용 목적
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>
                                                    필수정보
                                                </td>

                                                <td>
                                                    이름, 전화번호
                                                </td>

                                                <td>
                                                    견적 상담 및 고객 연락
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    문의정보
                                                </td>

                                                <td>
                                                    장비 종류, 행사일, 행사 장소, 행사 유형, 규모, 문의내용
                                                </td>

                                                <td>
                                                    장비 구성 및 설치 상담
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    선택정보
                                                </td>

                                                <td>
                                                    이메일
                                                </td>

                                                <td>
                                                    견적 및 상담 내용 전달
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </section>

                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                03
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    개인정보의 보유 및 이용기간
                                </h3>

                                <p>
                                    수집된 개인정보는 개인정보의 수집 및 이용 목적이 달성된 후
                                    지체 없이 파기하는 것을 원칙으로 합니다.
                                </p>

                                <p>
                                    다만 관련 법령에 따라 보존할 필요가 있는 경우에는
                                    해당 법령에서 정한 기간 동안 보관할 수 있습니다.
                                </p>
                            </div>
                        </section>

                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                04
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    개인정보의 제3자 제공
                                </h3>

                                <p>
                                    엠티미디어는 원칙적으로 고객의 개인정보를
                                    수집 및 이용 목적의 범위를 넘어 제3자에게 제공하지 않습니다.
                                </p>

                                <p>
                                    다만 고객의 사전 동의가 있거나 법령에 따라
                                    개인정보 제공이 요구되는 경우에는 예외로 할 수 있습니다.
                                </p>
                            </div>
                        </section>

                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                05
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    개인정보의 파기
                                </h3>

                                <p>
                                    개인정보의 보유기간이 경과하거나 처리 목적이 달성된 경우
                                    해당 개인정보를 안전한 방법으로 파기합니다.
                                </p>

                                <ul>
                                    <li>
                                        전자적 파일 형태의 정보는 복구할 수 없는 방법으로 삭제합니다.
                                    </li>
                                    <li>
                                        종이 문서 형태의 정보는 분쇄 또는 폐기 등의 방법으로 파기합니다.
                                    </li>
                                </ul>
                            </div>
                        </section>

                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                06
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    이용자의 권리 및 행사 방법
                                </h3>

                                <p>
                                    고객은 본인의 개인정보에 대해 열람, 정정,
                                    삭제 또는 처리 정지를 요청할 수 있습니다.
                                </p>

                                <p>
                                    관련 요청은 전화 또는 이메일을 통해 접수할 수 있으며,
                                    엠티미디어는 확인 후 필요한 조치를 진행합니다.
                                </p>
                            </div>
                        </section>

                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                07
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    개인정보의 안전성 확보 조치
                                </h3>

                                <p>
                                    엠티미디어는 개인정보가 분실, 도난, 유출,
                                    변조 또는 훼손되지 않도록 필요한 관리적·기술적 조치를 위해 노력합니다.
                                </p>

                                <ul>
                                    <li>
                                        개인정보 접근 권한 관리
                                    </li>
                                    <li>
                                        개인정보 취급 인원의 최소화
                                    </li>
                                    <li>
                                        개인정보가 저장된 시스템에 대한 접근 관리
                                    </li>
                                </ul>
                            </div>
                        </section>

                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                08
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    개인정보 보호책임자
                                </h3>

                                <p>
                                    개인정보와 관련한 문의 및 권리 행사는 아래 연락처를 통해 요청할 수 있습니다.
                                </p>

                                <div className="privacy-contact">
                                    <div>
                                        <span>
                                            개인정보 보호책임자
                                        </span>

                                        <strong>
                                            이경현
                                        </strong>
                                    </div>

                                    <div>
                                        <span>
                                            전화
                                        </span>

                                        <a href="tel:01090453707">
                                            010-9045-3707
                                        </a>
                                    </div>

                                    <div>
                                        <span>
                                            이메일
                                        </span>

                                        <a href="mailto:mtmedia91@gmail.com">
                                            mtmedia91@gmail.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="privacy-section">
                            <div className="privacy-section-number">
                                09
                            </div>

                            <div className="privacy-section-content">
                                <h3>
                                    개인정보처리방침의 변경
                                </h3>

                                <p>
                                    본 개인정보처리방침은 관련 법령 또는 서비스 내용의 변경에 따라
                                    수정될 수 있으며, 변경되는 경우 홈페이지를 통해 안내합니다.
                                </p>

                                <div className="privacy-date">
                                    <span>
                                        시행일
                                    </span>

                                    <strong>
                                        2026년 9월 27일
                                    </strong>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Privacy;